<script>
	import { Link } from 'svelte-routing';
	import { orderStore } from '../stores/order.store';
	import { currencyFormatter } from '../lib/utils';

	$: {
		console.log($orderStore);
	}
</script>

<section class="container section">
	<h2 class="my-sp">Orders List</h2>
	<table>
		<thead>
			<tr>
				<th>Order Number</th>
				<th>Date</th>
				<th>Items</th>
				<th>Order Total</th>
				<th> Action </th>
			</tr>
		</thead>
		<tbody>
			{#each $orderStore as item}
				<tr>
					<td>
						{item.orderNumber}
					</td>
					<td>
						{new Date(item.createdAt).toLocaleDateString('en-US', {
							year: 'numeric',
							month: 'long',
							day: 'numeric',
						})}
					</td>
					<td>
						{item?.quantities}
					</td>
					<td>
						{currencyFormatter.format(item?.total)}
					</td>
					<td>
						<Link style="color:cornflowerblue" to={`/order-details/${item.id}`}
							>View</Link
						>
					</td>
				</tr>
			{/each}
		</tbody>
	</table>
</section>

<style>
	.container {
		height: 650px;
	}
	.my-sp {
		margin-bottom: 20px;
	}
	table {
		width: 100%;
		border-collapse: collapse;
	}
	th,
	td {
		padding: 8px;
		text-align: left;
		border-bottom: 1px solid #ddd;
	}
	th {
		background-color: #5d5d5d;
	}
	tr {
		padding: 5px;
	}
	tr:hover {
		background-color: #f5f5f5;
	}
</style>
